// extracted by mini-css-extract-plugin
export default {"feed_search_query_input":"feed_feed_search_query_input__Jq1qF"};